













































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import Form77Service from "@/services/Form77";
import FormPrefillService from "@/services/FormPrefillService";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketForm77 from "@/store/modules/SuketForm77";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketForm77TabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // Form 77 dapat diterbitkan di poli MCU/umum mana pun → izinkan seluruh unit.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.Form77);
  suketStore = StoreSuketForm77;
  suketCategory = EnSuketCategory.Form77;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  tim_id: any = null;
  consent_sensitif = false;
  keperluan: any = null;
  timList: any[] = [];

  pegawai: any = {
    nip: null,
    pangkat: null,
    jabatan: null,
    instansi: null,
    instansi_pemohon: null,
    surat_permohonan: null
  };
  anamnesis: any = {
    keluhan: null,
    rps: null,
    merokok: null,
    alkohol: null
  };
  riwayat: any = {
    hipertensi: null,
    dm: null,
    jantung: null,
    paru: null,
    ginjal: null,
    hati: null,
    saraf: null,
    keganasan: null,
    jiwa: null,
    pms: null
  };
  fisik: any = {
    keadaan_umum: "Baik",
    kesadaran: "Compos mentis",
    td_sistolik: null,
    td_diastolik: null,
    nadi: null,
    rr: null,
    suhu: null,
    spo2: null,
    tb: null,
    bb: null
  };
  organ: any = {
    kepala: null,
    leher: null,
    visus_od: null,
    visus_os: null,
    buta_warna: "Normal",
    tht: null,
    pendengaran: null,
    gigi_mulut: null,
    jantung: null,
    paru: null,
    abdomen: null,
    ekstremitas: null,
    kulit: null,
    neuro: null,
    jiwa: null
  };
  penunjang: any = {
    hb: null,
    leukosit: null,
    trombosit: null,
    gol_darah: null,
    gd_puasa: null,
    urin: null,
    thorax: null,
    ekg: null
  };
  kesimpulan: any = {
    diagnosis: null,
    narasi: null,
    kategori: null,
    catatan: null,
    rekomendasi: null,
    masa_berlaku: "6 bulan"
  };

  openPanels = [0, 2, 5];
  saving = false;
  tarikLoading = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  keperluanOptions = [
    "Calon Pegawai Negeri Sipil (CPNS)",
    "Calon PPPK / P3K",
    "Kenaikan Pangkat",
    "Mutasi / Promosi Jabatan",
    "Pendidikan & Pelatihan",
    "Tugas ke Luar Negeri",
    "Pensiun / Janda-Duda",
    "Pemberhentian",
    "Calon Jamaah Haji",
    "Calon Tenaga Nakes / BLUD RSPS",
    "Lainnya"
  ];
  kategoriOptions = [
    { text: "A — Memenuhi Syarat Kesehatan", value: "A" },
    { text: "B — Memenuhi Syarat dengan Catatan", value: "B" },
    { text: "C — Tidak Memenuhi Syarat untuk Jabatan Tertentu", value: "C" },
    { text: "D — Tidak Memenuhi Syarat", value: "D" },
    { text: "E — Ditangguhkan / Perlu Pemeriksaan Lanjutan", value: "E" }
  ];
  butaWarnaOptions = ["Normal", "Buta warna parsial", "Buta warna total"];
  riwayatFields = [
    { key: "hipertensi", label: "Hipertensi" },
    { key: "dm", label: "Diabetes Melitus" },
    { key: "jantung", label: "Penyakit Jantung" },
    { key: "paru", label: "Penyakit Paru" },
    { key: "ginjal", label: "Penyakit Ginjal" },
    { key: "hati", label: "Penyakit Hati" },
    { key: "saraf", label: "Saraf / Epilepsi" },
    { key: "keganasan", label: "Keganasan / Kanker" }
  ];
  organFields = [
    { key: "kepala", label: "Kepala" },
    { key: "leher", label: "Leher" },
    { key: "tht", label: "THT" },
    { key: "gigi_mulut", label: "Gigi & Mulut" },
    { key: "jantung", label: "Jantung" },
    { key: "paru", label: "Paru" },
    { key: "abdomen", label: "Abdomen" },
    { key: "ekstremitas", label: "Ekstremitas" },
    { key: "kulit", label: "Kulit" },
    { key: "neuro", label: "Neurologis" },
    { key: "jiwa", label: "Status Jiwa" }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get imt() {
    const bb = Number(this.fisik.bb);
    const tb = Number(this.fisik.tb);
    if (bb > 0 && tb > 0) {
      return (bb / Math.pow(tb / 100, 2)).toFixed(1);
    }
    return "";
  }

  get imtKet() {
    const v = Number(this.imt);
    if (!v) return "";
    if (v >= 30) return "Obesitas II";
    if (v >= 25) return "Obesitas I";
    if (v >= 23) return "Berat badan lebih";
    if (v >= 18.5) return "Normal";
    return "Berat badan kurang";
  }

  get catatanRules() {
    if (this.kesimpulan.kategori && this.kesimpulan.kategori !== "A") {
      return [v => (!!v && v.length >= 50) || "Wajib diisi minimal 50 karakter"];
    }
    return [];
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.Form77, this.dataSuket.id)
      : null;
  }

  get roster() {
    const c: any = this.dataSuket && this.dataSuket.content;
    return c && c.tim ? c.tim : null;
  }

  get locked() {
    const c: any = this.dataSuket && this.dataSuket.content;
    return !!(c && c.locked);
  }

  get rosterRows() {
    const t: any = this.roster;
    if (!t) return [];
    const rows: any[] = [];
    if (t.ketua) {
      rows.push({ ...t.ketua, peranLabel: "Ketua Tim" });
    }
    (t.anggota || []).forEach((a: any) => {
      rows.push({ ...a, peranLabel: "Anggota" });
    });
    (t.ngt || []).forEach((a: any) => {
      rows.push({ ...a, peranLabel: "NGT" });
    });
    return rows;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        tim_id: this.tim_id,
        consent_sensitif: this.consent_sensitif,
        keperluan: this.keperluan,
        pegawai: this.pegawai,
        anamnesis: this.anamnesis,
        riwayat: this.riwayat,
        fisik: this.fisik,
        organ: this.organ,
        penunjang: this.penunjang,
        kesimpulan: this.kesimpulan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  mounted() {
    this.loadTimList();
    this.hydrate(this.dataSuket);
  }

  async loadTimList() {
    try {
      const resp = await Form77Service.listTim({ aktif: 1, per_page: 100 });
      const payload = resp && resp.data ? resp.data : resp;
      this.timList = payload && payload.data ? payload.data : [];
    } catch (e) {
      this.timList = [];
    }
  }

  hydrate(d: any) {
    this.register_id = (d && d.register_id) || this.register;
    this.pasien_rm = (d && d.pasien_rm) || this.pasien.rm;
    this.unit_id = (d && d.unit_id) || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.surat_date = (d && d.surat_date) || new Date();
    this.signee_user_id = (d && d.signee_user_id) || this.user.id;
    this.creator_user_id = (d && d.creator_user_id) || this.user.id;

    const c = d && d.content;
    if (c) {
      this.tim_id = c.tim_id || (c.tim && c.tim.tim_id) || null;
      this.consent_sensitif = !!c.consent_sensitif;
      this.keperluan = c.keperluan || null;
      this.pegawai = { ...this.pegawai, ...(c.pegawai || {}) };
      this.anamnesis = { ...this.anamnesis, ...(c.anamnesis || {}) };
      this.riwayat = { ...this.riwayat, ...(c.riwayat || {}) };
      this.fisik = { ...this.fisik, ...(c.fisik || {}) };
      this.organ = { ...this.organ, ...(c.organ || {}) };
      this.penunjang = { ...this.penunjang, ...(c.penunjang || {}) };
      this.kesimpulan = { ...this.kesimpulan, ...(c.kesimpulan || {}) };
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  openSign() {
    this.modalTtd = true;
  }

  // Override: tanda tangan per anggota Tim Penguji (bukan single-signee generik).
  passTtd(value) {
    appModule.setLoading(true);
    Form77Service.signMember(this.dataSuket.id, value)
      .then(dt => {
        if (dt.status == 1 || dt.status == "1") {
          appModule.NoticeDelay(dt.message || "Berhasil Tanda Tangan");
          this.suketStore.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  save() {
    if (this.saving) return;

    if (!this.tim_id) {
      appModule.sendErrorAlert("Tim Penguji Kesehatan wajib dipilih");
      return;
    }
    if (!this.kesimpulan.kategori) {
      appModule.sendErrorAlert("Kategori kelaikan wajib diisi");
      return;
    }
    if (
      this.kesimpulan.kategori !== "A" &&
      (this.kesimpulan.catatan || "").length < 50
    ) {
      appModule.sendErrorAlert(
        "Catatan/justifikasi wajib minimal 50 karakter bila kategori bukan A"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        this.suketStore.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async tarikAsesmen() {
    if (this.tarikLoading) return;
    this.tarikLoading = true;
    try {
      const payload = await FormPrefillService.fetchPrefill(
        this.pasien_rm,
        "suket_form_77",
        { register_id: this.register_id, sources: ["klinis_terkini"] }
      );
      const fields = payload && payload.fields ? payload.fields : {};
      const map = {
        "fisik.keadaan_umum": "keadaan_umum",
        "fisik.kesadaran": "kesadaran",
        "fisik.td_sistolik": "td_sistolik",
        "fisik.td_diastolik": "td_diastolik",
        "fisik.nadi": "nadi",
        "fisik.rr": "rr",
        "fisik.suhu": "suhu",
        "fisik.spo2": "spo2",
        "fisik.tb": "tb",
        "fisik.bb": "bb"
      };
      const fisik = { ...this.fisik };
      let n = 0;
      Object.keys(map).forEach(path => {
        const v = fields[path];
        if (v !== undefined && v !== null && v !== "") {
          fisik[map[path]] = v;
          n++;
        }
      });
      this.fisik = fisik;
      if (n > 0) {
        appModule.NoticeDelay(
          n + " nilai pemeriksaan fisik terisi dari asesmen perawat"
        );
      } else {
        appModule.sendErrorAlert(
          "Belum ada TTV/antropometri asesmen perawat pada kunjungan ini"
        );
      }
    } finally {
      this.tarikLoading = false;
    }
  }

  close() {
    this.expandInput = false;
  }
}
